import React, { useContext } from 'react';
import { BaseFeedEditorHotspotProps } from '@go-client/lib/feedEditor';
import { FeedEditorHotspot } from '@go-client/components';
import { FeedArea } from '@go-shared/types/feedTemplate';
import { ObjectId } from 'bson';
import { BareContentTemplateLegacy } from '@go-shared/types/contentTemplate';
import { FeedEditorCtx } from '@go-client/context/FeedEdtitorContext';

export const SailingDateWidgetHotspot: React.FC<BaseFeedEditorHotspotProps> = ({
  area,
  contentTemplate,
  onDrop,
  selectedLanguage,
  showMergedVars,
  highlightAreas,
  editorLocked,
  mcmKey,
}) => {
  let { dailyProgram } = useContext(FeedEditorCtx);
  if (!dailyProgram) {
    return <div>Loading ...</div>;
  }
  return (
    <div className="relative w-full">
      <FeedEditorHotspot
        onElementCreated={() => null}
        onElementChanged={() => null}
        onColumnCreated={() => null}
        onRowMove={() => null}
        onRowCreated={() => null}
        onContentChange={() => null}
        onAreaDeleted={() => null}
        contentTemplate={contentTemplate}
        key={area.content!._id}
        area={area}
        onDrop={onDrop}
        selectedLanguage={selectedLanguage}
        showMergedVars={showMergedVars}
        highlightAreas={highlightAreas}
        editorLocked={editorLocked}
        mcmKey={mcmKey}
      />
    </div>
  );
};

export const generateSailingDateWidgetArea = (ct: BareContentTemplateLegacy): FeedArea => {
  return {
    _id: new ObjectId().toHexString(),
    rectangle: {
      x: 100,
      y: 100,
      width: 0,
      height: 0,
    },
    style: {},
    className: 'w-full',
    contentType: 'date-widget',
    content: {
      _id: ct._id,
      content: ct.content,
      name: ct.name,
      property: ct.property,
    },
  };
};
